import angular from 'angular';

(function() {
    'use strict';

    angular.module('app').component('scheduler', {
        template: require('./scheduler.html'),
        controller: Ctrl,
        controllerAs: 'vm'
    });

    Ctrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$filter',
        '$cookies',
        'ModalService',
        'QueryService',
        'logger'
    ];

    function Ctrl(
        $scope,
        $state,
        $stateParams,
        $filter,
        $cookies,
        ModalService,
        QueryService,
        logger
    ) {
        var vm = this;
        vm.user = { id: $stateParams.id };

        vm.route_name = 'douhgfyasssoid';
        vm.loading = false;
        vm.handleDelete = handleDelete;
        vm.getData = getData;

        //config
        vm.dates = [];
        vm.times = [];

        function getData(key, hour, day) {
            vm.loading = true;
            var request = {
                method: 'GET',
                body: false,
                hasFile: false,
                route: { scheduler: '' },
                cache: false,
                cache_string: vm.route_name
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.data = response.data.data.items;
                        console.log(vm.data);
                        vm.loaded_data = 1;

                        vm.has_module_1 = vm.data.find(d => d.teacher_id === $stateParams.id && d.module_no === '1');
                        vm.has_module_2to4 = vm.data.find(d => d.teacher_id === $stateParams.id && d.module_no === '2 to 4');

                    },
                    function(error) {
                        logger.error(error.data.message);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        getSettings();
        function getSettings() {
            vm.loading = true;
            var request = {
                method: 'GET',
                body: false,
                hasFile: false,
                route: { settings: 'scheduler' },
                cache: false,
                cache_string: vm.route_name
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        vm.data = response.data.data;
                        
                        vm.times = vm.data.times;
                        vm.infographic = vm.data.infographic;
                        vm.durations = vm.data.durations;

                        vm.dates = vm.data.dates
                            .sort((a,b)=> a-b)
                            // .filter(a => new Date(a) > new Date())
                            // .slice(0, 5);

                        getData();

                    },
                    function(error) {
                        logger.error(error.data.message);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        function handleDelete(data) {
            var request = {
                method: 'DELETE',
                body: {},
                params: false,
                hasFile: false,
                route: { salary_rubrik: data.id }
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        logger.success('Schedule Deleted');
                        getData();
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                    vm.disable = false;
                });
        }

        vm.book = function(date, time) {
            const data = {
                start: new Date(`${date} ${time.start}`),
                teacher_id: vm.user.id,
                module_no: $stateParams.module_no,
            };

            vm.loading = true;
            var request = {
                method: 'POST',
                body: data,
                hasFile: false,
                route: { scheduler: '' },
                cache: false,
                cache_string: vm.route_name
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        logger.success(
                            `You have successfully booked ${date} ${time.start}`
                        );
                        $state.go ('scheduler', { module_no: '2 to 4', id: $stateParams.id });
                    },
                    function(error) {
                        
                        console.log('err', error.data);

                        if(error.data.message.indexOf('ER_DUP_ENTRY') !=-1){
                            logger.error('You can only book two slots. Please cancel your booking first.');
                        }else{
                            logger.error(error.data.message || error.data.errors[0].message);
                        }
                    }
                )
                .finally(function() {
                    getData();
                    vm.loading = false;
                });
        };

        vm.unbook = (date, time) => {
            vm.loading = true;
            var request = {
                method: 'DELETE',
                body: false,
                hasFile: false,
                route: { scheduler: vm.get_cell(date, time).scheduler_id },
                cache: false,
                cache_string: vm.route_name
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        // vm.option_table.data = response.data.data.items;
                        if(vm.has_module_2to4){
                            $state.go ('scheduler', { module_no: '2to4', id: $stateParams.id });
                        }else{
                            $state.go ('scheduler', { module_no: 1, id: $stateParams.id });
                        }
                    },
                    function(error) {
                        console.log('err', error.data);

                        if(error.data.message.indexOf('ER_DUP_ENTRY') !=-1){
                            logger.error('You can only book two slots, please cancel your booking first');
                        }else{
                            logger.error(error.data.message || error.data.errors[0].message);
                        }
                    }
                )
                .finally(function() {
                    getData();
                });
        };

        vm.get_cell = (date, time) => {
            if(vm.data && typeof vm.data.find === 'function'){

                return vm.data.find(
                    i =>
                    new Date(i.start).toISOString() ===
                    new Date(`${date} ${time.start}`).toISOString()
                    );
            }
        };

        vm.copyStringToClipboard = str => {

            str = `Skype ID:${str.skype_id}\,Skype Name:${str.skype_name}\nLive ID: ${str.live_id}`

            // Create new element
            var el = document.createElement('textarea');
            // Set value (string to be copied)
            el.value = str;
            // Set non-editable to avoid focus and move outside of view
            el.setAttribute('readonly', '');
            el.style = { position: 'absolute', left: '-9999px' };
            document.body.appendChild(el);
            // Select text inside element
            el.select();
            // Copy text to clipboard
            document.execCommand('copy');
            // Remove temporary element
            document.body.removeChild(el);

            logger.success(`Copied to Clipboard`);
        };
    }
})();



// WEBPACK FOOTER //
// ./src/app/components/scheduler/scheduler.component.js